<ng-container *ngIf="!loading else myloading">
    <button mat-icon-button aria-label="QR code exportieren" (click)="exportasPdf()" matTooltip="QR code exportieren">
        <mat-icon>qr_code_2</mat-icon>
    </button>
</ng-container>

<ng-template #myloading>
    <mat-spinner diameter="20"></mat-spinner>
</ng-template>